module.exports = __webpack_public_path__ + "img/hzLogo6.6391cc56.png";